import React, { ChangeEventHandler } from 'react';
import { useEditFormContext } from '../context';
import { Box, Checkbox, Grid, Typography } from '@material-ui/core';
import { DatePickerInput } from 'components/app/childrens/ui/DatepickerInput';
import { useStyles } from './styles';
import { WrappedTextfield } from 'components/Inputs/WrappedTextField';
import moment from 'moment';

export const Fields = () => {
  const {
    title,
    setTitle,
    description,
    setDescription,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    newQuestionRequired,
    setNewQuestionRequired
  } = useEditFormContext();
  const styles = useStyles();
  const handleChangeTitle: ChangeEventHandler<HTMLInputElement> = (event) => setTitle(event.target.value);
  const handleChangeDescription: ChangeEventHandler<HTMLInputElement> = (event) => setDescription(event.target.value);

  const handleChangeNewQuestionRequired: ChangeEventHandler<HTMLInputElement> = (event) =>
    setNewQuestionRequired(event.target.checked);

  return (
    <div className={styles.fields}>
      <Box>
        <WrappedTextfield
          title="Título do Formulário"
          variant="outlined"
          value={title}
          onChange={handleChangeTitle}
          charLimit={100}
        />
        <label className={styles.requirementInput}>
          <Typography className={styles.title}>Obrigatório</Typography>
          <Checkbox value={newQuestionRequired} onChange={handleChangeNewQuestionRequired} />
        </label>
      </Box>

      <Box>
        <Typography className={styles.title}>Descrição</Typography>
        <WrappedTextfield
          variant="outlined"
          value={description}
          onChange={handleChangeDescription}
          multiline
          charLimit={4000}
        />
      </Box>

      <Box>
        <Typography className={styles.title}>Data</Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <DatePickerInput
              value={startDate}
              label="Início Vigência"
              handleChange={setStartDate}
              modalTitle="Data Início Vigência"
              minDate={moment().add(1, 'day').toDate()}
            />
          </Grid>
          <Grid item xs={6}>
            <DatePickerInput
              value={endDate}
              label="Fim Vigência"
              handleChange={setEndDate}
              modalTitle="Data Início Vigência"
              minDate={startDate || undefined}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};
